import React from "react";
import PropTypes from "prop-types";
import { defineMessages, injectIntl } from "react-intl";
import IconButton from "theme/components/atoms/Button/IconButton";

const messages = defineMessages({
  open: {
    id: "components.atoms.ToggleButton.openTitle",
    defaultMessage: "Open",
  },
  close: {
    id: "components.atoms.ToggleButton.closeTitle",
    defaultMessage: "Close",
  },
});

const ToggleButton = ({ expanded = false, onToggle, intl }) => {
  return (
    <IconButton
      title={
        expanded
          ? intl.formatMessage(messages.close)
          : intl.formatMessage(messages.open)
      }
      icon={expanded ? "chevron-up" : "chevron-down"}
      iconSize="small"
      onClick={onToggle}
    />
  );
};

ToggleButton.propTypes = {
  expanded: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

export default injectIntl(ToggleButton);
